import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token:'',
    accountId:'',
    uniqueId:'',
    userid:0,
    actInfo:{},
    actExtend:{},
    topGroup:{},
    groups:{},
    commends:{},
  },  
  mutations: {    

    SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_ACCOUNTID(state, accountId) {
      state.accountId = accountId;
    },
    SET_UNIQUEID(state, uniqueId) {
      state.uniqueId = uniqueId;
    },
    SET_USERID(state, userid) {
      state.userid = userid;
    },
    SET_ACTINFO(state, actInfo) {
      state.actInfo = actInfo;
    },
    SET_TOPGROUP(state, topGroup) {
      state.topGroup = topGroup;
    },
    SET_GROUPS(state, groups) {
      state.groups = groups;
    },
    SET_COMMENDS(state, commends) {
      state.commends = commends;
    },

  },
  actions: {
  },
  modules: {
  },
  getters: {
  }
})
